import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, RFFormInput, RFFormRadioGroup, Button } from 'virtues-bootstrap';
import { ReactComponent as IconPlusSolid } from 'svg/plus-solid.svg';
import { ReactComponent as Trash } from 'svg/trash.svg';
import { normalizePhone } from 'services/normalize';
import s from './styles.module.scss';

const Phones = ({ fields, meta: { error, submitFailed }, t }) => (
  <Col xs={9} lg={7}>
    {fields.map((field, index) => (
      <div key={field} className={s.phoneWrapper}>
        <div className={s.phone}>
          <Field
            placeholder="+1 (647) 765 4321"
            component={RFFormInput}
            name={`${field}.phone`}
            normalize={normalizePhone}
            type="text"
          />
        </div>
        <RFFormRadioGroup
          className={s.radioGroup}
          groupName={`${field}.type`}
          radioButtons={[
            { label: t('addPatient.landline'), value: 'home' },
            { label: t('addPatient.mobile'), value: 'mobile' },
          ]}
          inline
        />
        {index > 0 && (
          <div
            role="button"
            className={s.deleteIcon}
            tabIndex={index}
            onKeyPress={() => fields.remove(index)}
            onClick={() => fields.remove(index)}
          >
            <Trash />
          </div>
        )}
        {submitFailed && error && <span className={s.phoneError}>{error}</span>}
      </div>
    ))}
    {fields.length < 2 && (
      <Button
        className={s.addButton}
        icon={<IconPlusSolid />}
        variant="link"
        type="button"
        onClick={() => fields.push()}
        size="sm"
      >
        {t('addPatient.addAnotherPhone')}
      </Button>
    )}
  </Col>
);

Phones.propTypes = {
  fields: PropTypes.objectOf(PropTypes.any).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    submitFailed: PropTypes.bool,
  }).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Phones);
